// extracted by mini-css-extract-plugin
module.exports = {"filter":"vYSwdG5spa1SHuOkCHOA"};